import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import style from "./Filter.module.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Form, Formik } from "formik";
import validationSchema from "../../../../../Validation/ValidationSchemas";
import FormikTextField from "../../../../../Common/FormFields/FormikInputField";
import { FormGroup } from "reactstrap";
import CustomDropDown from "../../../../../Common/FormFields/CustomDropDown";
import { setFilterValues } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
import { useDispatch } from "react-redux";
const FilterAccordion = ({
  className,
  filter,
  handleRemoveFilter,
  currentFilterList,
  setCurrentFilterList,
}) => {
  const dispatch = useDispatch();
  const [active, setActive] = useState(false);
  const [breakDownName, setBreakDownName] = useState("");
  const [condition, setCondition] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);
  const { filterValues, filterData: editFilterInformation } = useSelector(
    (state) => state?.videoLibraryFilterData
  );
  const activeBreakDownList = useSelector(
    (state) => state?.VideoLibraryDataTable?.activeBreakDownList
  );
  const conditionOptions = () => {
    let status = false;
    if (breakDownName) {
      const index = activeBreakDownList?.findIndex(
        (item) => item?.breakdownName === breakDownName
      );
      if (
        activeBreakDownList?.[index].breakdownType.breakdownTypeName === "Text"
      ) {
        status = true;
      }
    }
    let optionList = [
      {
        name: "EqualTo",
        operator: "===",
        disabled: false,
      },
      {
        name: "NotEqualTo",
        operator: "!==",
        disabled: status,
      },
      {
        name: "GreaterThan",
        operator: ">",
        disabled: status,
      },
      {
        name: "LessThan",
        operator: "<",
        disabled: status,
      },
      {
        name: "Between",
        operator: "<>",
        disabled: status,
      },
    ];

    return optionList;
  };

  const handleRemoveValue = (filterId, value) => {
    //mapping is id => value
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [filterId]: prevValues[filterId].filter(
        (itemValue) => itemValue !== value
      ),
    }));
    const updatedValues = filterValues
      ?.map((el) => {
        if (el.value.includes(value) && filterId == el.id) {
          const updatedValueArray = el.value.filter((item) => value !== item);
          return updatedValueArray.length > 0
            ? {
                ...el,
                value: updatedValueArray,
              }
            : null;
        } else {
          return el;
        }
      })
      .filter(Boolean);
    setFilterValues(dispatch, updatedValues);
  };

  const handleSubmit = (values, setSubmitting) => {
    setSubmitting(true);
    const filterList = {
      id: filter?.id,
      value: selectedValues[filter.id],
      operator: values?.conditionName,
      breakDownName: values?.breakDownName,
      filterName: currentFilterList[0]?.filterName,
    };
    const updatedCurrentfilterList = currentFilterList.map((ele) => {
      return ele.id === filter.id ? filterList : ele;
    });
    setCurrentFilterList(updatedCurrentfilterList);
    setFilterValues(dispatch, [...(filterValues || []), filterList]);
    setSubmitting(false);
  };
  return (
    <li className={className}>
      <div className="d-flex-space-between">
        <span style={{ marginInlineStart: "5px" }}>{filter.filterName}</span>
        <div className="d-flex-align-cent gap-10">
          <button
            className="breakdownTableCloseIcon"
            onClick={() => setActive((active) => !active)}
          >
            <span>{active ? <FaAngleUp /> : <FaAngleDown />}</span>
          </button>
          <button
            className="breakdownTableCloseIcon"
            onClick={() => handleRemoveFilter(filter)}
          >
            <span>&times;</span>
          </button>
        </div>
      </div>
      <div className={`${style.AccordionContent} ${active && style.active}`}>
        <Formik
          initialValues={{
            breakDownName: "",
            conditionName: "",
            conditionValue: "",
          }}
          validationSchema={validationSchema.AddFilterSchema}
          onSubmit={(values, { setSubmitting }) =>
            handleSubmit(values, setSubmitting)
          }
        >
          {(formik, values) => (
            <Form>
              <FormGroup
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "360px",
                }}
              >
                <CustomDropDown
                  selected={breakDownName}
                  setSelected={setBreakDownName}
                  formik={formik}
                  fieldName="breakDownName"
                  defaultSelectOption={"Select BreakDown"}
                  options={activeBreakDownList}
                  fieldToShow="breakdownName"
                  optionValue="breakdownName"
                />
                <CustomDropDown
                  selected={condition}
                  setSelected={setCondition}
                  formik={formik}
                  fieldName="conditionName"
                  defaultSelectOption={"Select Condition"}
                  options={conditionOptions()}
                  fieldToShow="name"
                  optionValue="operator"
                  isDisabled="disabled"
                />
              </FormGroup>
              <FormGroup
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "360px",
                }}
              >
                <FormikTextField
                  formik={formik}
                  fieldName="conditionValue"
                  placeholder="Set Condition Value"
                  labelFontSize="fs-14"
                  customClassNames={`${style.fieldWidth} formik-input-field instn fs-16 regular olnone share-popup-input fmlabel black`}
                />
                <button
                  type="button"
                  className="small-btn fs-16"
                  style={{ margin: "8px 10px 40px 20px" }}
                  disabled={!formik.values.conditionValue || !formik.isValid}
                  onClick={() => {
                    setSelectedValues((prevValues) => ({
                      ...prevValues,
                      [filter.id]: [
                        ...(prevValues[filter.id] || []),
                        formik.values.conditionValue,
                      ],
                    }));
                    formik.setFieldValue("conditionValue", "");
                  }}
                >
                  Add
                </button>
              </FormGroup>
              <div className={style.AccordionContentDropDownMultiSelectField}>
                {selectedValues[filter.id]?.map((value, index) => (
                  <div
                    key={index}
                    className={`mg-right-10 d-flex-align-cent ${style.multiSelectInputChip}`}
                  >
                    <span>{value}</span>
                    <span
                      className="mg-left-10 fs-18"
                      onClick={() => handleRemoveValue(filter.id, value)}
                    >
                      &times;
                    </span>
                  </div>
                ))}
              </div>
              <div
                className={`${style.applyButton} d-flex-align-right mg-top-10`}
              >
                <button
                  type="submit"
                  className="small-btn fs-16"
                  disabled={!formik.isValid || !selectedValues[filter.id]}
                >
                  Apply
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </li>
  );
};

export default FilterAccordion;
